export default __webpack_public_path__ + "static/media/manage-handy-tap.0c555d88.svg";